export default __webpack_public_path__ + "static/media/undraw_phone_call_grmk 1.f2a47c00.svg";